export enum SpinnerState {
  START = 'start',
  VISIBLE = 'visible',
  CACHE = 'cache',
}
